import React, { PureComponent } from 'react';
import { strCount, pluralHelper } from '../../../../helpers/stringutils';
import ResponsiveImage from '../../../shared/responsiveImage';
import DaysPanel from './days-panel';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import ButtonSpinner from '../../../shared/UI/button-spinner';
import { get } from '../../../../helpers/objectHelper';
import { ampmConvert } from '../../../../helpers/utils';
import { itineraryListData } from '../../../../helpers/itineraryHelper';

dayjs.extend(AdvancedFormat);


class BuilderCard extends PureComponent{

    constructor(props){
        super(props);
        this.state = {
            daysPanelVisible:false
        }
        this.closeClicked = this.closeClicked.bind(this);
        this.plusClicked = this.plusClicked.bind(this);
        this.nightClicked = this.nightClicked.bind(this);
        this.arrowClicked = this.arrowClicked.bind(this);
        this.hideDaysPanel = this.hideDaysPanel.bind(this);
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.itinerary.length !== prevProps.itinerary.length){
            this.hideDaysPanel();
        }
    }

    closeClicked(){
        this.props.onCloseClicked();
    }
    
    plusClicked(){
        this.props.onPlusClicked();
    }

    nightClicked(){
        this.setState({daysPanelVisible: !this.state.daysPanelVisible});
    }

    arrowClicked(){
        this.props.onArrowClicked();
    }
    
    hideDaysPanel(){
        if(this.state.daysPanelVisible) this.setState({daysPanelVisible: false});
    }

    render(){

        const { daysPanelVisible } = this.state;
        const { showClose, showPlus, showArrow, index, id, builderData, itinerary, isLoading, filteredItinerary } = this.props;
        
        const _itinerary = (itinerary === undefined) ? [] : itinerary;
        const _isLastItem = (_itinerary !== undefined && index === _itinerary.length - 1) ? true : false;

        const _name = (id === "builder-view" || id === 'itinerary-view') ? builderData.to : builderData.name;
        const _date = `${dayjs(builderData.date).format("D MMM")} - ${dayjs(builderData.endDate).format("D MMM")}` ;

        let _image = get(['cityInfo', 'hero', 0], builderData, "");
        if(_image === "/" || _image === "")  _image = "//images.ctfassets.net/3ng3kfj0qs70/2qGNBKyZcldU1Xh0BrQtg5/f01ac093180302084aa9055be40d4df1/Busabout.jpg";

        
        let _hasAccommodation, _accommodationData, _nightButtonActive, _panelClickFunction;
        if(id === "builder-view"){
            _nightButtonActive = (_itinerary !== undefined && index === _itinerary.length - 1) ? false : true;
        }
        if(id === 'itinerary-view'){
            _nightButtonActive = true;
            _panelClickFunction = showArrow ? this.arrowClicked : null;
            _hasAccommodation =  (_itinerary[index].accommodation === null || _itinerary[index].accommodation.reservations === null || _itinerary[index].nights === 0) ? false : true;
            _accommodationData = {
                nights:_hasAccommodation ? _itinerary[index].accommodation.nights : "",
                type:_hasAccommodation ? _itinerary[index].accommodation.reservations[0].type : "",
                propertyType: _hasAccommodation ? _itinerary[index].accommodation.reservations[0].propertyType : "" 
            }
        }
        if(id === "builder-view" || id === "next-destination-view"){
            _panelClickFunction = showPlus ? this.plusClicked : null;
        }
        
        let _nextDepartureMessage, _nextDepartureLastMessage;
        if(id === "builder-view" || id === "itinerary-view"){
            //TODO - refactor into helper
            const filteredIndex = filteredItinerary.findIndex(item => item.id === _itinerary[index].id);
            const _nextDepartureName = (!_isLastItem && filteredItinerary[filteredIndex+1]) ? filteredItinerary[filteredIndex+1].to : filteredItinerary[filteredItinerary.length-1].to ;
            const _nextDepartureTime = (!_isLastItem && filteredItinerary[filteredIndex+1]) ? filteredItinerary[filteredIndex+1].departure : filteredItinerary[filteredItinerary.length-1].departure;
            const _lastArrivalTime = filteredItinerary[filteredItinerary.length-1].arrival;
            const _isPreTrip = (!_isLastItem && (filteredItinerary[filteredIndex].type === "start" || filteredItinerary[filteredIndex].type === "city") && filteredItinerary[filteredIndex+1].type === "product") ? true : false;
            const _isPostTrip = (!_isLastItem && filteredItinerary[filteredIndex].type === "city" && filteredItinerary[filteredIndex-1].type === "product") ? true : false;
            const { productStartAddress, cityOrProductName, departTime } = itineraryListData(filteredIndex+1, filteredItinerary);

            _nextDepartureMessage =  (_itinerary.length >= 1 && _nextDepartureTime !== null) ? 
            _isPreTrip ? `Make your way to ${cityOrProductName} before the trip starts ${dayjs(builderData.endDate).format("D MMM")} at ${ampmConvert(departTime).toLowerCase()} from ${productStartAddress}` : 
            _isPostTrip ? `Coach departing from ${_name} to ${_nextDepartureName} on ${dayjs(builderData.endDate).format("D MMM")} at ${ampmConvert(_nextDepartureTime).toLowerCase()}` : 
            `Coach departing from ${_name} to ${_nextDepartureName} on ${dayjs(builderData.endDate).format("D MMM")} at ${ampmConvert(_nextDepartureTime).toLowerCase()}` 
            : "";

            _nextDepartureLastMessage = (_itinerary.length >= 1 && _lastArrivalTime !== null) ? 
            `Trip ends with Busabout on ${dayjs(builderData.date).format("D MMM")} at ${ampmConvert(_lastArrivalTime).toLowerCase()} and you will stay in ${filteredItinerary[filteredItinerary.length-1].to} until the ${dayjs(builderData.endDate).format("D MMM")}` : 
            `Trip ends with Busabout on ${dayjs(builderData.date).format("D MMM")} and you will stay in ${filteredItinerary[filteredItinerary.length-1].to} until the ${dayjs(builderData.endDate).format("D MMM")}`;
        }


        return (
            <>
            <div className={`panel small-panel builder round-corners ${id}`} onClick={ _panelClickFunction }>
                <div className={`clearfix flex ${isLoading ? 'loading' : ''}`}>
                    <div className="col col-2 flex">
                        <ResponsiveImage width={111} widthRetina={222} src={_image} alt={""} quality={60} id={id}/>
                    </div>
                    <div className={`col pl3 flex flex-column justify-center ${_isLastItem ? 'col-5' : 'col-6'}`}>
                        <p className={`trip-name ${strCount(_name, 21, 'small')}`}>{_name}</p>

                        {(id === "builder-view" || id === "itinerary-view") && index === 0 && <p className="subtext bold">{ (builderData.nights === null || builderData.nights === 0) ? _date.split(" - ")[0] : _date } : Pre-Trip </p> }
                        {(id === "builder-view" || (id === "itinerary-view" && !_isLastItem)) && index > 0 && <p className="subtext bold">{_date}</p> }
                        {(id === "itinerary-view" && _isLastItem) && <p className="subtext bold">{ builderData.nights === 0 ? _date.split(" - ")[0] : _date} : Post-Trip </p> }
                    </div>
                    <div className={`col pr2 flex justify-end items-center ${_isLastItem ? 'col-5' : 'col-4'}`}>

                        {
                            (id === "itinerary-view") && builderData.type !== "product" && (
                            <p className="right-align mr2">
                                { !_hasAccommodation && <span className="agent-portal-grey">Accommodation <br/> not included</span> }
                                { 
                                    _hasAccommodation && <>
                                        <span className="green-text bold">{_accommodationData.nights} {pluralHelper('night', _accommodationData.nights)} </span>
                                        <span className="block agent-portal-grey">{_accommodationData.type !== "hotel" ? _accommodationData.propertyType : ""} {_accommodationData.type} room</span>
                                    </>
                                }
                            </p> 
                            ) 
                        } 
                          
        
                        {   
                           (id === "builder-view") && builderData.type !== "product" && (
                                <button className="nights-btn mr3 bold" onClick={this.nightClicked} disabled={_nightButtonActive}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15" height="16" className="mr1">
                                        <path fill="currentColor" d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path>
                                    </svg>
                                  {builderData.nights || 0}  Nights
                                </button>
                            )
                        }
         

                        { showClose && (_isLastItem) &&  
                            <svg className="inline-block button close-svg" xmlns="http://www.w3.org/2000/svg" height="22.627" width="22.627" onClick={this.closeClicked}>
                                <path fill="#3D3D3D" transform="rotate(45 11.314 11.314)" fillRule="evenodd" d="M18.98 10.314h-6.666V3.647a.333.333 0 0 0-.334-.333h-1.333a.333.333 0 0 0-.333.333v6.667H3.647a.333.333 0 0 0-.333.333v1.333c0 .185.149.334.333.334h6.667v6.666c0 .185.149.334.333.334h1.333c.185 0 .334-.15.334-.334v-6.666h6.666c.185 0 .334-.15.334-.334v-1.333"/>
                            </svg>
                        }

                        { showPlus && 
                            <svg className="inline-block button plus-svg" xmlns="http://www.w3.org/2000/svg" height="16" width="16">
                                <path fill="#FF6700" fillRule="evenodd" d="M15.667 7H9V.333A.333.333 0 0 0 8.667 0H7.333A.333.333 0 0 0 7 .333V7H.333A.333.333 0 0 0 0 7.333v1.334C0 8.85.15 9 .333 9H7v6.667c0 .184.15.333.333.333h1.334c.184 0 .333-.15.333-.333V9h6.667c.184 0 .333-.15.333-.333V7.333"/>
                            </svg>
                        }

                        { showArrow && 
                            <svg className="inline-block button arrow-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="18" height="18">
                                <path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/>
                            </svg>
                        }

                    </div>
                </div>  
                { isLoading && <div className="clearfix flex loading-spinner"><div className="col col-12 flex items-center"><ButtonSpinner /></div></div> }               
           </div>
           <p className="mt1 agent-portal-grey regular f-size-12">
              {(!_isLastItem) && _nextDepartureMessage}
              {(_isLastItem && index !== 0) && _nextDepartureLastMessage}
            </p>

            { daysPanelVisible && <DaysPanel onCloseClicked={this.hideDaysPanel} index={index} nights={builderData.nights} /> }
            </>
        )
    }

}

const mapStateToProps = state => {
    return{
        itinerary:state.currentBooking.itinerary,
        filteredItinerary:state.currentBooking.filteredItinerary,
        isLoading:state.cart.update_sector_loading
    }
}

export default connect(mapStateToProps, null)(BuilderCard);